<template>

  <div class="page">

    <!--Title/Actions-->
    <div class="page-header flex-shrink-0 mb-3 bg-white border-bottom">
      <div class="container-fluid d-flex justify-content-between align-items-center px-md-4 px-3">
        <h3 class="mb-0"><i class="fas fa-th"></i>&nbsp;Event Categories</h3>
        <div>
          <button class="btn btn-primary" @click="doSort" title="Sort Event Types"><i class="fas"
              :class="{ 'fa-sort-amount-down': sortDirection === 'asc', 'fa-sort-amount-up': sortDirection === 'desc' }"></i></button>
        </div>
      </div>
    </div>

    <!--Search-->
    <div class="container-fluid px-md-4 px-3 py-3 bg-white border-bottom mb-3">
      <div class="row no-gutters">
        <div class="col-lg-4 col-md-6">
          <b-input-group>
            <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search"
              @input="doSearch"></b-form-input>
          </b-input-group>
        </div>
        <b-button :disabled="!filter" variant="link" @click="filter = ''">Clear</b-button>
      </div>
    </div>

    <!--Table-->
    <div class="pt-3 flex-grow-1 overflow-auto">
      <div class="container-fluid px-md-4 px-3">
        <div v-for="type in eventTypes" v-bind:key="type.id">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <h5 class="mb-0">
              <strong>{{type.name}}</strong>
            </h5>
            <b-link class="btn btn-success" @click="showNewCategoryEditor(type)">
              <i class="fas fa-plus"></i>
            </b-link>
          </div>
          <b-table-simple bordered class="rg-table mb-5">
            <b-tbody>
              <b-tr v-for="category in type.categories" v-bind:key="category.id">
                <b-td>{{category.name}}</b-td>
                <b-td class="table-action text-center" style="width: 100px">
                  <a class="btn btn-link" @click="showCategoryEditor(category, type)">
                    <i class="fas fa-edit text-primary"></i>
                  </a>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </div>
    </div>

    <b-modal v-model="shouldShowCategoryEditor" hide-footer title="Add/Edit Category" no-close-on-backdrop>
      <div v-if="editCategory">
        <b-form>
          <b-form-group>
            <label for="inline-form-category-name">Name</label>
            <b-input-group>
              <b-input id="inline-form-category-name" class="" placeholder="CategoryName" v-model="editCategory.name">
              </b-input>
              <b-input-group-append>
                <b-button variant="success" @click="saveEditCategory()">Save</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'CategoryManager',
  created () {
    this.doLoadEventTypes()
  },
  components: {
  },
  data () {
    return {
      sortDirection: 'asc',
      filter: '',
      shouldShowCategoryEditor: false,
      eventTypes: {},
      editCategory: null,
      editCategoryType: null
    }
  },
  computed: {
  },
  methods: {
    ...mapActions('events', ['getEventTypes']),
    ...mapActions('company', ['saveCategory', 'createCategory']),
    doLoadEventTypes () {
      var request = { sortBy: 'Name', sortDirection: this.sortDirection, search: this.filter }
      return this.getEventTypes(request).then(result => {
        console.log('event types returned: ' + JSON.stringify(result.data, null, 2))
        this.eventTypes = result.data.eventTypes
      })
    },
    toggleCategoryEditor () {
      this.shouldShowCategoryEditor = !this.shouldShowCategoryEditor
    },
    showCategoryEditor (category, type) {
      this.editCategory = Object.assign({}, category)
      this.editCategoryType = type
      this.toggleCategoryEditor()
    },
    showNewCategoryEditor (type) {
      this.editCategory = {}
      this.editCategoryType = type
      this.toggleCategoryEditor()
    },
    saveEditCategory () {
      const categoryToSave = Object.assign({}, this.editCategory)
      categoryToSave.typeId = this.editCategoryType.id
      var action = this.saveCategory
      if (!categoryToSave.id) {
        action = this.createCategory
      }
      action(categoryToSave).then(r => {
        this.doLoadEventTypes().then(() =>
          this.toggleCategoryEditor()
        )
      })
    },
    doSort () {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      this.doLoadEventTypes()
    },
    doSearch () {
      this.doLoadEventTypes()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/setup/Categories.vue